import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box, Button, Divider, FormControl, FormHelperText, FormLabel, HStack, Image, Input, Stack, Text } from '@chakra-ui/react';
import GooglePlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-google-places-autocomplete';
import React, { useCallback, useEffect, useState } from 'react';
import { fetchCompany, getUser, updateCompany, updateCompanyRegNumber } from '../../store/actions';
import { useAppDispatch, useAppSelector } from '../../hooks';

import { AppDispatch } from '../../store';
import CompanyLogo from '../../theme/assets/company-placeholder.png';
import { ToastContainer } from 'react-toastify';
import { addCompanyFormValidation } from '../../utils';
import { companyFormTypes } from '../../types';
import { useFormik } from 'formik';

export const CompanySettings = () => {

    const [origin, setOrigin] = useState<any | null>(null);
    const [coords, setCoords] = useState<any | null>(null);
    // const [image, setImage] = useState<any>();
    const [isUpdatingRagNumber, setUpdatingRegNumber] = useState<boolean>(false);
    const [companyRegNumber, setCompanyRegNumber] = useState<string>('');

    const { company, is_updating_company } = useAppSelector(state => state.companyReducer);
    const { company_reg_number, company_id } = company ?? {};

    const dispatch: AppDispatch = useAppDispatch();

    const updateCompanyForm = useFormik({
        initialValues: {
            name: '',
            phone: '',
            email: '',
            address: '',
            coords: {
                lat: '',
                long: '',
            }
        },
        validationSchema: addCompanyFormValidation,
        validateOnBlur: true,
        onSubmit: (values: companyFormTypes) => {
            const address = origin?.label || values.address;
            const newValues = { ...values, ...company, address, coords, name: values.name };
            dispatch(updateCompany(`${company._id}`, newValues));
            // alert(JSON.stringify({...newValues}, null, 2));
        }
    });

    // const changeHandler = (event: any) => {
    //     setImage(event.target.files[0]);
    // };

    // const handleUpload = async () => {
    //     const formData = new FormData();

    //     formData.append('upload_logo', image);

    //     dispatch(uploadLogo(formData));
    // };

    const getCoords = useCallback(() => {
        origin && geocodeByAddress(origin?.label)
            .then((results: Array<any>) => getLatLng(results[0]))
            .then(({ lat, lng }: any) => {
                setCoords({ lat: lat, long: lng });
            }
            );
    }, [origin]);

    const setDefaultValues = useCallback(() => {
        updateCompanyForm.setFieldValue('name', company?.name);
        updateCompanyForm.setFieldValue('phone', company?.phone);
        updateCompanyForm.setFieldValue('email', company?.email);
        updateCompanyForm.setFieldValue('address', company?.address);
        setCompanyRegNumber(company_reg_number);
    }, []);

    const handleUpdateVatOptionUpdate = () => {
        setUpdatingRegNumber(true);
        dispatch(updateCompanyRegNumber({
            company_id,
            company_reg_number: companyRegNumber
        }))
            .then(() => setUpdatingRegNumber(false))
            .catch(() => setUpdatingRegNumber(false));
    };

    useEffect(() => { }, [updateCompanyForm.values]);

    useEffect(() => {

        dispatch(getUser());
        dispatch(fetchCompany());
        getCoords();
        setCompanyRegNumber(company_reg_number);

        return () => {
            // dispatch(fetchCompany(user?.email));
            setDefaultValues();
        };
    }, []);

    return (
        <Stack bg={'#FFFFFF'} p={6} borderRadius={6} >
            <Stack>
                <HStack justifyContent={'space-between'}>
                    <Text textTransform={'capitalize'} fontWeight={'semibold'} fontSize={'1.5rem'} >Update company</Text>
                </HStack>
                <Divider />
                <HStack py={6} justifyContent={'center'}>
                    <Image
                        borderRadius={'lg'}
                        boxShadow={'md'}
                        boxSize='150px'
                        alt={'Logo placeholder'}
                        src={CompanyLogo}
                    />{' '}
                    {/* <Stack pl={4}>
                        <input className="custom-file-input" name='upload_logo' type='file' onChange={changeHandler} />
                        <Button colorScheme='yellow' size='sm' onClick={handleUpload}>
                            Upload logo
                        </Button>
                        <Button leftIcon={<FiTrash2 />} variant={'outline'} colorScheme='red' size='sm'>
                            Delete
                        </Button>
                    </Stack> */}
                </HStack>
            </Stack>
            <Stack>
                <Accordion defaultIndex={[0, 1]} allowMultiple>
                    <AccordionItem boxShadow={'md'} borderRadius={4} border={'none'}>
                        <h2>
                            <AccordionButton bg={'gray.50'} minH={'50px'}>
                                <Box as='span' flex='1' textAlign='left' fontWeight={'medium'}>
                                    Company Details
                                </Box>
                                <AccordionIcon />
                            </AccordionButton>
                        </h2>
                        <AccordionPanel pb={4}>
                            <form onSubmit={updateCompanyForm.handleSubmit}>
                                <FormControl id='name' isRequired mb={updateCompanyForm.errors.name ? 0 : 5} maxW={'sm'}>
                                    <FormLabel>Company name</FormLabel>
                                    <Input name='name' type='text' value={updateCompanyForm.values.name} onChange={updateCompanyForm.handleChange} />
                                    {updateCompanyForm.errors.name && <Text fontSize='sm' color='red.400'>{updateCompanyForm.errors.name}</Text>}
                                </FormControl>
                                <HStack>
                                    <Box w={['full', 'sm']}>
                                        <FormControl id='phone' isRequired mb={updateCompanyForm.errors.phone ? 0 : 5}>
                                            <FormLabel>Phone number</FormLabel>
                                            <Input name='phone' type='text' value={updateCompanyForm.values.phone} onChange={updateCompanyForm.handleChange} />
                                            {updateCompanyForm.errors.phone && <Text fontSize='sm' color='red.400'>{updateCompanyForm.errors.phone}</Text>}
                                        </FormControl>
                                    </Box>
                                    <Box w={['full', 'sm']}>
                                        <FormControl id='email' isRequired mb={updateCompanyForm.errors.email ? 0 : 5}>
                                            <FormLabel>Email</FormLabel>
                                            <Input disabled name='email' type='email' value={updateCompanyForm?.values?.email} onChange={updateCompanyForm.handleChange}/>
                                            {updateCompanyForm.errors.email && <Text fontSize='sm' color='red.400'>{updateCompanyForm.errors.email}</Text>}
                                        </FormControl>
                                    </Box>
                                </HStack>
                                <FormControl id='address' isRequired mb={origin ? 3 : 5}>
                                    <FormLabel>Address</FormLabel>
                                    <GooglePlacesAutocomplete
                                        apiKey='AIzaSyCsvDO2ZMssvwhcmIo2TqXvJSL0zlMD5bw'
                                        apiOptions={{ region: 'za' }}
                                        selectProps={{
                                            placeholder: 'Address',
                                            origin,
                                            onChange: setOrigin
                                        }}
                                    />
                                    {/* <Input name='address' type="text" value={companyForm.values.address} onChange={companyForm.handleChange} /> */}
                                    {!origin && <Text fontSize='sm' color='red.400'>{'Enter your address'}</Text>}
                                </FormControl>
                                <Stack spacing={10} pt={2}>
                                    <Button
                                        type='submit'
                                        isLoading={is_updating_company}
                                        isDisabled={!coords || is_updating_company}
                                        size='lg'
                                        colorScheme={'yellow'}
                                        >
                                        Submit
                                    </Button>
                                </Stack>
                            </form>
                        </AccordionPanel>
                    </AccordionItem>
                    <AccordionItem boxShadow={'md'} borderRadius={4} border={'none'} mt={4}>
                        <h2>
                            <AccordionButton bg={'gray.50'} minH={'50px'}>
                                <Box as='span' flex='1' textAlign='left' fontWeight={'medium'}>
                                    Company Registration Number
                                </Box>
                                <AccordionIcon />
                            </AccordionButton>
                        </h2>
                        <AccordionPanel pb={4}>
                            <HStack justifyContent={'space-between'}>
                                <FormControl maxW={'sm'}>
                                    <FormLabel>Reg. number</FormLabel>
                                    <Input
                                        size={'md'}
                                        value={companyRegNumber}
                                        onChange={(event) => setCompanyRegNumber(event.target.value)}
                                        placeholder='43578/345687/234'
                                    />
                                    <FormHelperText>CIPC registration number.</FormHelperText>
                                </FormControl>
                                <Button
                                    mt={'5px !important'}
                                    size={'md'}
                                    isLoading={isUpdatingRagNumber}
                                    disabled={isUpdatingRagNumber}
                                    colorScheme={'yellow'}
                                    _hover={{
                                        bg: 'black',
                                        color: 'white',
                                    }}
                                    onClick={handleUpdateVatOptionUpdate}
                                >Update</Button>
                            </HStack>
                        </AccordionPanel>
                    </AccordionItem>
                </Accordion>

            </Stack>
            <ToastContainer />
        </Stack>
    );
};